import AuthenticationType from '@alltrails/analytics/enums/AuthenticationType';
import type { User } from 'types/User';
import CurrencyCode from 'types/CurrencyCode';
import authSuccessCallback from './AuthHandlers';

export const appleRedirectHandler = (user: User) => {
  const params = new URLSearchParams(window.location.search);
  const appleOAuth = params.get('apple_oauth');
  const isCollabListInvite = params.get('is_collab_list_invite') === 'true';
  const currencyCode = params.get('currency_code');
  if (appleOAuth) {
    const is_sign_up = appleOAuth === 'signup';
    authSuccessCallback({ is_sign_up, user, currencyCode: currencyCode as CurrencyCode }, AuthenticationType.Apple, isCollabListInvite);
    params.delete('apple_oauth');
    const search = params.toString();
    window.history.replaceState(null, null, window.location.pathname + (search !== '' ? `?${search}` : ''));
  }
};

export default appleRedirectHandler;
